import React, { Fragment } from "react";

import Box from "./Box";
import HeadingMedium from "./HeadingMedium";
import Link from "next/link";
import PropTypes from "prop-types";
import Text from "./Text";

const LATEST_DROP_TITLE = "Latest drop";

function BreadcrumbTitle({ title }) {
  return (
    <HeadingMedium as="h1" uppercase>
      {title}
    </HeadingMedium>
  );
}

function BreadcrumbSmallText({ children, ...props }) {
  return (
    <Text fontSize={[14, 14, 16, 16]} uppercase fontWeight={700} {...props}>
      {children}
    </Text>
  );
}

function ListingsBreadcrumb({ brand, isLatestDrop, category }) {
  const brandHref = brand ? `/${brand.slug}` : null;
  if (isLatestDrop) {
    return (
      <Box>
        {brand ? (
          <Fragment>
            <Box display="flex" mb={10}>
              <Link href={brandHref}>
                <Box
                  as="a"
                  cursor="pointer"
                  transition="opacity 200ms"
                  hover="opacity: 0.5"
                >
                  <BreadcrumbSmallText>{brand.name}</BreadcrumbSmallText>
                </Box>
              </Link>
            </Box>
            <BreadcrumbTitle title={LATEST_DROP_TITLE} />
          </Fragment>
        ) : (
          <Fragment>
            <Box display="flex" mb={10}>
              <BreadcrumbSmallText>Reskinned</BreadcrumbSmallText>
            </Box>
            <BreadcrumbTitle title={LATEST_DROP_TITLE} />
          </Fragment>
        )}
      </Box>
    );
  }

  if (!category.categorySlug) {
    // This is a root category
    return (
      <Box>
        <Box display="flex" mb={10}>
          <BreadcrumbSmallText>{category.name}</BreadcrumbSmallText>
        </Box>

        <BreadcrumbTitle title={`All ${category.name}`} />
      </Box>
    );
  } else {
    const rootCategoryHref = `/${
      category.brandSlug ? category.brandSlug + "/" : ""
    }${category.rootCategorySlug}`;
    return (
      <Box>
        <Box display="flex" mb={10}>
          <Link href={rootCategoryHref}>
            <Box
              as="a"
              cursor="pointer"
              transition="opacity 200ms"
              hover="opacity: 0.5"
            >
              <BreadcrumbSmallText>
                {category.rootCategoryName}
              </BreadcrumbSmallText>
            </Box>
          </Link>
          {category.parentSlug && (
            <Fragment>
              <BreadcrumbSmallText mx="5px">/</BreadcrumbSmallText>
              <Link href={`${rootCategoryHref}/${category.parentSlug}`}>
                <Box
                  as="a"
                  cursor="pointer"
                  transition="opacity 200ms"
                  hover="opacity: 0.5"
                >
                  <BreadcrumbSmallText>
                    {category.parentName}
                  </BreadcrumbSmallText>
                </Box>
              </Link>
            </Fragment>
          )}
        </Box>
        <BreadcrumbTitle title={category.name} />
      </Box>
    );
  }
}

export default ListingsBreadcrumb;

ListingsBreadcrumb.propTypes = {
  brand: PropTypes.object,
  rootCategory: PropTypes.object,
  isLatestDrop: PropTypes.bool,
};
